import { queryOptions } from '@tanstack/react-query'
import { getBlockedDates, getEnquiries, getEnquiry, getLeadAttentionCounts, getLeadOwners } from '../lib/api'

export const leadKeys = {
	all: ['leads'] as const,
	enquiries: () => [...leadKeys.all, 'enquiries'] as const,
	enquiry: (id: number) => [...leadKeys.all, 'enquiry', id] as const,
	blockedDates: () => [...leadKeys.all, 'blocked-dates'] as const,
	attentionCounts: () => [...leadKeys.all, 'attention-counts'] as const,
	owners: () => [...leadKeys.all, 'owners'] as const,
}

export const enquiriesQuery = () => queryOptions({ queryKey: leadKeys.enquiries(), queryFn: getEnquiries })

export const enquiryQuery = (id: number) => queryOptions({ queryKey: leadKeys.enquiry(id), queryFn: () => getEnquiry(id) })

export const blockedDatesQuery = () => queryOptions({ queryKey: leadKeys.blockedDates(), queryFn: getBlockedDates })

export const leadAttentionQuery = () => queryOptions({ queryKey: leadKeys.attentionCounts(), queryFn: getLeadAttentionCounts })

export const leadOwnersQuery = () => queryOptions({ queryKey: leadKeys.owners(), queryFn: getLeadOwners, staleTime: 5 * 60 * 1000 })
